export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Требуется подтверждение"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Авторизацию необходимо подтвердить одноразовым ключом"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Авторизацию необходимо подтвердить волшебным словом"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Регистрацию необходимо подтвердить кодом из смс-сообщения"])}
}